export interface Example {
    marker: string;
    activationPhrase: string;
    request: string;
}

export interface ReservedWords {
    words: string[];
    inflected: string[];
}

export const isEmptyExample = (example: Example): boolean =>
    !example.marker && !example.activationPhrase && !example.request;

export const markers: { text: string; hasRequest: boolean }[] = [
    { text: 'запусти навык', hasRequest: false },
    { text: 'запусти чат с', hasRequest: false },
    { text: 'давай поиграем в', hasRequest: false },
    { text: 'сыграем в', hasRequest: false },
    { text: 'давай сыграем в', hasRequest: false },
    { text: 'поиграем в', hasRequest: false },
    { text: 'скажи', hasRequest: true },
    { text: 'попроси', hasRequest: true },
    { text: 'узнай у', hasRequest: true },
    { text: 'спроси у', hasRequest: true },
];

export const reservedWords: ReservedWords = {
    words: ['алиса', 'яндекс', 'станция'],
    inflected: [
        'алиса',
        'алису',
        'алисе',
        'алисы',
        'алисой',
        'яндекс',
        'яндекса',
        'яндексу',
        'яндексом',
        'яндексе',
        'станция',
        'станции',
        'станцию',
        'станций',
    ],
};

export const triggers: string[] = markers.map((x) => x.text);

export const quotedTriggers: string = triggers.map((t) => `"${t}"`).join(', ');

export const quotedReserved: string = reservedWords.words.map((t) => `"${t}"`).join(', ');

export const tokenize = (text: string): string[] => {
    const regex = /([a-zа-я]+)/gu;
    const tokens = text.match(regex);
    return tokens || [];
};

export const containsOneOf = (text: string, items: string[]): boolean => {
    const normalized = items.map((i) => i.toLowerCase()).filter(Boolean);
    return normalized.some((i) => text.indexOf(i) !== -1);
};

export const isQuoted = (text: string): boolean => /^['"❝«].*['"„»]$/.test(text);
